export const BaseUrl = "https://Clouducf.inaipi.me/v1";
export const excelDownloadUrl = "https://Clouduce.inaipi.me/files";
export const newBaseUrlLang = "https://Clouducf.inaipi.me/";
export const ticketUrl = "https://Clouducg.inaipi.me/ticketing";
export const errorApi = "https://Clouducg.inaipi.me/logs/v1";
export const SocketUrl = "https://Clouducg.inaipi.me";
export const emailservice = "https://Clouducg.inaipi.me/email/email/";
export const baseUrlEmail = "https://Clouducg.inaipi.me/email/email/";
export const AvcUrl = "https://Clouducg.inaipi.me/voice/voicechat";
export const emailDownloadUrl = "https://Clouducg.inaipi.me/email/files";
export const frontendBaseurl = "https://Clouduce.inaipi.me";
export const fileservice = "https://qacc.inaipi.ae/v1";
export const BaseUrlSurvey = "https://cms.inaipiapp.com/DccSurvey/public/api";
export const CoBroswseUrl = "https://clouducg.inaipi.me/email/email/";
export const TenantID = "123456";
export const VoiceDomainName = "ucd.inaipi.me";
export const VoiceDomainNamePure = "purecs.inaipi.me";
export const BaseUrlReports = "https://Clouducg.inaipi.me/powerbi/";
export const systemTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
export const versionCode = "1.8";
export const logoutTime = 3600000;
